import React from "react";
import PropTypes from "prop-types";

import Footer from "../NewLayout/footer";
import HeaderV2 from "../NewLayout/Header";
import SidebarV2 from "../NewLayout/Sidebar";

const AppLayout = ({ children }) => (
  <>
    <div className="page-wrapper">
      <div className="page-body-wrapper">
        <div className="d-flex">
          <div style={{ width: "70px" }}>
            <SidebarV2 />
          </div>
          <div className="page-body" style={{ width: "calc(100% - 70px)", marginBottom: "45px", backgroundColor: "#FFF" }}>
            <HeaderV2 />
            {children}
            <Footer />
          </div>
        </div>
      </div>
    </div>
  </>
);

AppLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default AppLayout;
